module.exports = __webpack_public_path__ + "img/logic-task.568ac912.svg";